import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateAddressBookPage } from './create-address-book.page';

const routes: Routes = [
  {
    path: '',
    component: CreateAddressBookPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateAddressBookPageRoutingModule {}
